import { authFetch } from "./authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

async function request(projectId, uploadId, suffix, init) {
  const response = await authFetch(`${BACKEND_URL}/project/${encodeURIComponent(projectId)}/file_history/${encodeURIComponent(uploadId)}${suffix}`, init);
  const result = await response.json().catch(() => null);
  return { ...result, success: response.ok && result?.success === true, status: response.status };
}

export function getFileHistoryCandidates(projectId, uploadId, { page = 1, search = "", signal } = {}) {
  return request(projectId, uploadId, `/candidates?${new URLSearchParams({ page, search })}`, { signal });
}

export function getFileMetadataHistory(projectId, uploadId, ids = [], signal) {
  return request(projectId, uploadId, "/compare", { method: "POST", signal,
    headers: { "Content-Type": "application/json" }, body: JSON.stringify({ upload_ids: ids }) });
}
